import React, { useEffect, useState } from 'react';
import { API_CONFIG } from '../../config/api';

export const DEFAULT_PROFILE_IMAGE = '/images/default-profile.svg';

type Props = {
  src?: string | null;
  alt?: string;
  className?: string;
};

function resolveUrl(src: string) {
  if (/^https?:\/\//i.test(src)) return src;
  if (src.startsWith('/api/')) return `${API_CONFIG.BASE_URL}${src.slice(4)}`;
  return src;
}

const ProfileAvatar: React.FC<Props> = ({ src, alt = 'Profile', className }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const image = failed || !src ? DEFAULT_PROFILE_IMAGE : resolveUrl(src);

  return (
    <img
      src={image}
      alt={alt}
      className={className || 'h-16 w-16 rounded-full object-cover bg-gray-100'}
      onError={() => setFailed(true)}
    />
  );
};

export default ProfileAvatar;
